import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { user } from '../../../../shared/interfaces/user'
import { AuthService } from '../../../../shared/services'
import { environment } from 'src/environments/environment';


@Component({
    selector: 'app-account-menu',
    templateUrl: './account-menu.component.html',
    styleUrls: ['./account-menu.component.scss']
})
export class AccountMenuComponent implements OnInit {
    environment=environment;
    @Output() closeMenu: EventEmitter<void> = new EventEmitter<void>();

    model: user = { email: '', password: '' };
    loggedinuser: user = null;
    constructor(private service: AuthService,
        private toastr: ToastrService,) {
    }

    ngOnInit() {
        this.service.getuserlistener().subscribe(res=>{
            this.loggedinuser = res;
        });
    }
    async login() {
        if (this.model.email == "" || this.model.email == "") {
            this.toastr.error(`Please enter email and password`);
            return;
        }
        this.service.signin(this.model).then(res => {
            if(res['status']=="success"){
                this.toastr.success(`Login Successfull`,'Success'); 
                this.loggedinuser = res["data"];
                this.closeMenu.emit(); 
            }
            else{
                this.toastr.info(`Email or password does not match`,"Info");    
            }
        });

    }
    async logout() {
        this.loggedinuser = null;
        this.service.logout();
        this.closeMenu.emit();
    }
}
